import SupplierClientPage from "../SupplierClientPage";

const VendorsPage = () => <SupplierClientPage supplierType="FORNECEDOR" translationPrefix="settings.vendor" />;

export default VendorsPage;
